import { render } from "./QAQCTestTabs.vue?vue&type=template&id=49045535"
import script from "./QAQCTestTabs.vue?vue&type=script&lang=js"
export * from "./QAQCTestTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__